<template>
  <div
    class="footer-box flex flex-center align-items-cnenter"
    :class="FootType === 1 ? 'bg-560a0f' : 'bg-B9202F'"
  >
    <div class="text-box flex flex-center align-items-cnenter">      
      <div>
        <!--<span>主办单位：{{$store.state.region | roleFilterText}}教育局</span>-->
        {{$store.state.region == 4 ? '协办单位：曲沃县中等职业技术学校':'技术支持：山西华兴科软有限公司'}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    FootType: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    // getRegion() {
    //   if (this.$store.state.region === 1) {
    //     return "吕梁市";
    //   } else if (this.$store.state.region === 2) {
    //     return "临汾市";
    //   } else {
    //     return "长治市";
    //   }
    // },
  },
};
</script>

<style scoped lang="scss">
.footer-box {
  // height: 60px;
  // line-height: 60px;
  padding: 10px 0;
  font-size: 19px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  // opacity: 0.87;
  // background: #001d97;
  background: #5D1000;
  text-align: center;
}
.text-box span{
  margin-right: 60px;
}
// .footer-box .text-box div {
//   margin: 0 20px;
// }
// .span-color-73151a {
//   color: #73151a;
// }
// .span-color-fff {
//   color: #fff;
// }
// .bg-560a0f {
//   background: #560a0f;
// }
// .bg-B9202F {
//   background: #b9202f;
// }
</style>
